import React, { Component, PropTypes } from 'react'
import { findDOMNode } from 'react-dom'
import { connect } from 'react-redux'
import styled from 'styled-components'
import _ from 'lodash'
import ImageViewer from 'wix-style-react/src/ImageViewer'
import { uploadToStorageVideo, uploadToStorage, removeFromStorage } from 'controllers/storage'
import { processImage, processVideo } from '../../../utils/uploadUtils'
import { displayError } from 'components/NotificationController'
import ImageCrop from './ImageCrop'

const Container = styled.label`
  position: relative;
  display: inline-flex;
`
const FileInputOutside = styled.input`
  visibility: hidden;
  position: absolute;
  width: 0px;
  height: 0px;
  top: -100em;
`
const VideoOutside = styled.div`
  position: absolute;
  top: -100em;
`
const FileInput = styled.input`
  visibility: hidden;
  position: absolute;
  top: 0px;
  bottom: 0px;
  right: 0px;
  left: 0px;
`
const StyledImageViewer = styled(ImageViewer)`
  width: 20px;
  height: 20px;
`

class UploadButton extends Component {

  constructor (props) {
    super(props)
    this.state = ({
      file: null
    })
  }

  saveFile = (file) => {
    const { dispatch, appId, fileId } = this.props
    if (this.props.onChooseFile) {
      this.props.onChooseFile(file)
    }

    const typeArray = _.split(file.type, '/')

    if (typeArray[0] === 'video') {
      processVideo(file).then(({videoFile, imageFile}) => {
        dispatch(uploadToStorageVideo(appId, videoFile, imageFile))
      }).catch(reason => {
        displayError(`${file.name} file upload failed.`)
      })
    } else if (typeArray[0] === 'image') {
      processImage(file).then((fileToUpload) => {
        dispatch(uploadToStorage(appId, fileToUpload, fileId))
      }).catch(reason => {
        displayError(`${file.name} file upload failed.`)
      })
    } else {
      dispatch(uploadToStorage(appId, file, fileId))
    }
  }

  onChooseFile = (e) => {
    const files = e.target.files
    // console.log('onChooseFile', files)
    if (files.length > 0) {
      const file = files[0]
      const typeArray = _.split(file.type, '/')
      if (typeArray[0] === 'image') {
        // console.log('file is image, set to state', file, 'current state', this.state.file)
        this.setState({file: file})
      } else {
        this.saveFile(file)
      }
    }

    return false
  }

  onVideoMounted = (ref) => { this.videoplayer = ref }

  onFileInputMounted = (ref) => { this.fileInput = ref }

  onAddImage = () => {
    const input = findDOMNode(this.fileInput)
    input.value = null
    input.click()
  }

  onRemoveImage = () => {
    const { dispatch, appId, fileId } = this.props
    if (fileId) dispatch(removeFromStorage(appId, fileId))
  }

  renderImageViewer () {
    const { imageUrl, filetypes } = this.props
    return (
      <div>
        <FileInputOutside
          type='file'
          accept={filetypes}
          onChange={this.onChooseFile}
          ref={this.onFileInputMounted}
        />
        <StyledImageViewer
          onAddImage={this.onAddImage}
          onUpdateImage={this.onAddImage}
          onRemoveImage={this.onRemoveImage}
          imageUrl={imageUrl}
        />
        <VideoOutside ref={this.onVideoMounted} />
        {this.renderCropModal()}
      </div>
    )
  }

  onCropComplete = (file) => {
    // console.log('onCropComplete', crop, pixelCrop)
    this.setState({file: null})
    if (!_.isNil(file)) this.saveFile(file)
  }

  renderCropModal = () => {
    const { file } = this.state
    if (!_.isNil(file)) {
      return (
        <ImageCrop
          file={file}
          onComplete={this.onCropComplete}
        />
      )
    }
  }

  renderChildren () {
    const { filetypes } = this.props
    return (
      <Container>
        {this.props.children}
        <FileInput
          type='file'
          accept={filetypes}
          onChange={this.onChooseFile}
        />
        <VideoOutside ref={this.onVideoMounted} />
        {this.renderCropModal()}
      </Container>
    )
  }

  render () {
    const { isImageViewer } = this.props
    if (isImageViewer) {
      return this.renderImageViewer()
    } else {
      return this.renderChildren()
    }
  }
}

UploadButton.defaultProps = {
  filetypes: 'image/jpeg,image/png,video/mp4',
  isImageViewer: true,
}

UploadButton.propTypes = {
  appId: PropTypes.string.isRequired,
  filetypes: PropTypes.string,
  fileId: PropTypes.string,
  isImageViewer: PropTypes.bool,
  imageUrl: PropTypes.string,
  onChooseFile: PropTypes.func,
}

export default connect()(UploadButton)



// WEBPACK FOOTER //
// ./src/components/editor/assetsManager/UploadButton.js